import styled from 'styled-components';

export const Container = styled.div`
  .followup-info-border {
    border-top: 5px solid ${(props) => props.theme.$dark};
  }
`;
